<div class="column gap" *ngIf="thematic" #page [class.fade-left]="fadeLeft$ | async" [class.fade-left-reverse]="fadeLeftReverse$ | async">
  <app-button class="center-horizontally-by-margin" icon="edit" *ngxPermissionsOnly="'admin'" (click)="editThematic()">{{ 'thematics.details.edit' | translate }}</app-button>
  <app-thematic-card [isDetailsPage]="true" [big]="true" [withoutTitle]="true" [thematic]="thematic"></app-thematic-card>

  <div class="translation-missing-banner" *ngIf="thematic.translationMissing">
    {{ 'thematics.details.translationMissing' | translate }}
  </div>

  <div class="space-between row">
    <h1 class="cooper title">{{ thematic.title | thematicField: thematic.slug:'title' }}</h1>
    <app-favorite-thematic [thematic]="thematic" />
  </div>
  <p><strong>{{ thematic.resume | thematicField: thematic.slug:'resume' }}</strong></p>
  <div class="info-tile row center-children-vertically">
    <div class="text-xl">
      <app-icon size="40" type="clock"/>
    </div>
    <p><strong>{{ 'thematics.details.sessionsBadge' | translate }}</strong> {{ 'thematics.details.sessionsBadgeHint' | translate }}</p>
  </div>

  <h2>{{ 'thematics.details.dependingOnNeeds' | translate }}</h2>
  <ul [class]=" categorySlug">
    <li *ngFor="let bulletPoint of workingOnBulletPoints">
      <span>{{bulletPoint}}</span>
    </li>
  </ul>

  <h2>{{ 'thematics.details.whichDynamic' | translate }}</h2>
  <app-dynamics class="dynamics" [thematic]="thematic" [canValidate]="isTalker" [goToAvailableTrains]="true"/>

  <div *ngIf="thematic.testimonials?.length">
    <h2 class="margin-bottom-xl margin-top-xl">{{ 'thematics.details.testimonials' | translate }}</h2>
    <app-slider *ngIf="thematic.testimonials" [items]="thematic.testimonials">
      <ng-template #slide let-item>
        <div class="testimonial" [class]="categorySlug">
          <div class="testimonial-content">
            <p class="margin-bottom">{{item.description}}</p>
            <p><strong>{{item.author}}</strong></p>
          </div>
        </div>
      </ng-template>
    </app-slider>
  </div>


  <div *ngIf="thematic.keyNumbers?.length">
    <h2 class="margin-top-xl">{{ 'thematics.details.keyNumbersTitle' | translate }}</h2>
    <div class="wrap gap">
      <div class="column margin-right" *ngFor="let keyNumber of thematic.keyNumbers">
        <p class="key-number cooper text-xl" [class]="categorySlug">{{keyNumber.stringNumber}}</p>
        <div class="key-number-description">{{keyNumber.description}}</div>
      </div>
    </div>
  </div>


  <div *ngIf="relatedThematics.length">
    <h2 class="margin-top margin-bottom">{{ (relatedThematics.length > 1 ? 'thematics.details.relatedMany' : 'thematics.details.relatedOne') | translate }}</h2>
    <div class="wrap gap">
      <div class="column" *ngFor="let relatedThematic of relatedThematics">
        <app-thematic-card
          [thematic]="relatedThematic" (click)="goToThematic(relatedThematic.slug)"></app-thematic-card>
        <app-favorite-thematic [thematic]="relatedThematic"></app-favorite-thematic>
      </div>
    </div>
  </div>
</div>
